import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { usePersonalization } from '@/hooks/usePersonalization';
import { HelpCircle } from 'lucide-react';

interface PersonalizedTooltipProps {
  content: string;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const PersonalizedTooltip: React.FC<PersonalizedTooltipProps> = ({
  content,
  children,
  side = 'top'
}) => {
  const { config } = usePersonalization();

  // Only show tooltips for beginners or new users
  if (!config.showTooltips) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1">
            {children}
            <HelpCircle className="h-3 w-3 text-muted-foreground" />
          </div>
        </TooltipTrigger>
        <TooltipContent side={side}>
          <p className="max-w-xs text-sm">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};